<template>
  <div class="text-center">
    <div class="success-icon-container">
        <span class="material-symbols-outlined success-icon">
          check_circle
        </span>
    </div>
    <h1 class="title password-changed-title">{{ title }}</h1>

    <div>
      <slot></slot>
    </div>

    <slot name="button"></slot>
  </div>
</template>

<script>
export default {
  name: 'SuccessView',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.success-icon-container {
  margin-bottom: 40px;
}

.success-icon {
  font-size: 7rem;
  font-variation-settings: 'FILL' 0, 'wght' 600, 'GRAD' 200, 'opsz' 24;
  color: transparent;
  text-shadow: 3px 3px 0 rgba(0, 0, 0, 0.12);

  background-color: $iconColorSuccess;
  background-image: linear-gradient(45deg, $iconColorSuccess, lighten($iconColorSuccess, 15%));
  background-clip: text;
}
</style>
